import { ConsumoAPI_POST } from "../backend/ConsumoAPI";

export async function verificarSessaoAtiva(usuario) {
	const res = await ConsumoAPI_POST('sessao/check', JSON.stringify({ usuario }))  
	const data = res.data;
	return !!data; // retorna true se a sessão ainda estiver ativa
}

export async function logoutSessao(usuario) {
	const res = await ConsumoAPI_POST('sessao/logout', JSON.stringify({ usuario }))  
}